var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "metodo-de-pago"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1308 -411L-1282 -411L-1282 -385L-1308 -385L-1308 -411Z",
    id: "metodo-de-pago",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "metodo-de-pago",
    component: "0a9deb53-4e86-4494-ab9c-955295f5290b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.875 1.625L8.125 1.625C6.77881 1.625 5.6875 2.71631 5.6875 4.0625L5.6875 21.9375C5.6875 23.2837 6.77881 24.375 8.125 24.375L17.875 24.375C19.2212 24.375 20.3125 23.2837 20.3125 21.9375L20.3125 4.0625C20.3125 2.71631 19.2212 1.625 17.875 1.625L17.875 1.625ZM8.125 3.25L17.875 3.25C18.3237 3.25 18.6875 3.61377 18.6875 4.0625L18.6875 19.5L7.3125 19.5L7.3125 4.0625C7.3125 3.61377 7.67627 3.25 8.125 3.25L8.125 3.25ZM18.6875 21.9375C18.6875 22.3862 18.3237 22.75 17.875 22.75L8.125 22.75C7.67627 22.75 7.3125 22.3862 7.3125 21.9375L7.3125 21.125L18.6875 21.125L18.6875 21.9375Z",
    id: "Shape",
    fill: "#4992CB",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14.5C12.3557 14.5 11.8333 13.9777 11.8333 13.3333C11.8333 12.689 11.311 12.1667 10.6667 12.1667C10.0223 12.1667 9.5 12.689 9.5 13.3333C9.50409 14.8128 10.4382 16.13 11.8332 16.6233L11.8333 16.8333C11.8333 17.4777 12.3557 18 13 18C13.6443 18 14.1667 17.4777 14.1667 16.8333L14.1667 16.6233C15.7591 16.0455 16.7092 14.4101 16.4223 12.7405C16.1354 11.0709 14.694 9.84648 13 9.83333C12.3557 9.83333 11.8333 9.311 11.8333 8.66667C11.8333 8.02234 12.3557 7.5 13 7.5C13.6443 7.5 14.1667 8.02233 14.1667 8.66666C14.1667 9.31099 14.689 9.83333 15.3333 9.83333C15.9777 9.83333 16.5 9.311 16.5 8.66667C16.4958 7.18698 15.5616 5.86983 14.1666 5.37665L14.1667 5.16667C14.1667 4.52234 13.6443 4 13 4C12.3557 4 11.8333 4.52233 11.8333 5.16666L11.8333 5.37667C10.2409 5.9545 9.29083 7.58987 9.5777 9.25946C9.86457 10.9291 11.306 12.1535 13 12.1667C13.4168 12.1667 13.802 12.389 14.0104 12.75C14.2188 13.111 14.2188 13.5557 14.0104 13.9167C13.802 14.2776 13.4168 14.5 13 14.5L13 14.5Z",
    id: "Shape",
    fill: "#07C180",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyPhone);
export default __webpack_public_path__ + "static/media/moneyPhone.aec3783f5e17603bb45883571c770212.svg";
export { ForwardRef as ReactComponent };